<template>
	<CommonForm 
		v-if="newOpen"
		:title="'Novo Produto de Decesso'"
		:open= "newOpen"
		:resetFormData= "resetFormData"
		:inputsList="inputs"
		@data="onSendFormData"
		@update-open="newOpen = false"
	/>

	<CommonEditingForm 
		v-if="editOpen"
		:open= "editOpen"
		:inputsList="inputs"
		:placeHolderValues= "editFormData"
		@editing-data= "onSendEditingData"
		@update-open= "editOpen = false"
	/>

	<Commonlisting
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:previous = "previous"
		:next = "next"
		:inputsListing= "inputs"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:resetFormData= "resetFormData"
		:editFormData= "editFormData"
		:importFile= "false"
		:useForms= "false"
		:fileOnly= "false"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@find-by-field= "filtered"
		@clean-filter= "cleanFilter"
		@send-form-data= "onSendFormData"
		@delete-data-id= "deleteData"
		@edit-alternative= "getEditData"
		@new-alternative="newEntry"
		@view-confirmation= "getEditData"
		@filter="openFilter = true"
	/>

	<FilterComponent
		:title="'decesso'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />

	<CommonLoading
		v-if="loading"
	/>
</template>

<script>
import Commonlisting from '@/components/generalcomponents/CommonListing';
import DecessosRepository from '@/services/DecessosRepository.vue';
import { pageVariables } from './PageVariablesDecessos';
import Swal from "sweetalert2";
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';
import CommonForm from '@/components/generalcomponents/CommonForm.vue';
import CommonEditingForm from '@/components/generalcomponents/CommonEditingForm.vue';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";

export default {
	name: 'DecessosView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(1)
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			editFormData:{},
			newOpen: false,
			editOpen: false,
			loading: false,
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			openFilter: false,
			filters: [],
			filterFields: [
				{
					name: "nome",
					label: "Nome",
					type: "input",
					placeholder: "Nome do produto"
				}
			]
		};
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const repo = new DecessosRepository();
			try {
				const response = await repo.getDecessos(this.onlineUser.token, page, this.filters);
				if (response?.status === 200) {
					this.data = response.data.data.map(item => ({
						sigla: item.sigla,
						nome: item.nome,
						valor_capital: item.valor_capital,
						valor_premio: item.valor_premio,
						created_at: item.created_at ? new Date(item.created_at).toLocaleDateString() : '-',
						id: item.id
					}));
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;
					this.next = response.data.next_page_url || "";
					this.previous = response.data.prev_page_url || "";
				}
				this.loading = false;
			} catch (error) {
				this.loading = false;
				this.mostrarAlertaErro(error);
			}
		},
		newEntry(){
			this.newOpen = true;
		},
		async onSendFormData(data){
			this.loading = true; 
			const repo = new DecessosRepository();
			try {
				const response = await repo.createDecesso(1, data, this.onlineUser.token);
				if (response?.status === 200 || response?.status === 201) {
					this.pageData(1);
					this.mostrarAlerta();
					this.newOpen = false;
				} else {
					this.mostrarAlertaErro(response?.data?.message || "Erro ao criar");
				}
				this.loading = false;
			} catch (error) {
				this.loading = false;
				this.mostrarAlertaErro(error);
			}	
		},
		async onSendEditingData(data, id){
			this.loading = true; 
			const repo = new DecessosRepository();
			try {
				const response = await repo.updateDecesso(1, this.onlineUser.token, id, data);
				if (response?.status === 200) {
					this.pageData(this.currentPage);
					this.mostrarAlerta();
					this.editOpen = false;
				} else {
					this.mostrarAlertaErro(response?.data?.message || "Erro ao atualizar");
				}
				this.loading = false;
			} catch (error) {
				this.loading = false;
				this.mostrarAlertaErro(error);
			}	
		},
		async deleteData(id){
			Swal.fire({
				title: 'Tem certeza?',
				text: "Você não poderá reverter isso!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Sim, deletar!'
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.loading = true; 
					const repo = new DecessosRepository();
					try {
						await repo.deleteDecesso(1, this.onlineUser.token, id);
						this.mostrarAlerta();
						this.pageData(this.currentPage);
					} catch (error) {
						this.mostrarAlertaErro(error);
					}
					this.loading = false;
				}
			});
		},
		async getEditData(id){
			this.loading = true;
			const repo = new DecessosRepository();
			try {
				const response = await repo.getDecesso(1, this.onlineUser.token, id);
				if (response?.status === 200) {
					this.editFormData = response.data;
					this.editOpen = true;
				}
				this.loading = false;
			} catch (error) {
				this.loading = false;
				this.mostrarAlertaErro(error);
			}	
		},
		handleFilters(rawFilters){
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(1);
		},
		goTo(number){
			this.pageData(number);
		},
		filtered(){
		},
		cleanFilter(){
			this.filters = [];
			this.pageData(1);
		},
		mostrarAlerta() {
			Swal.fire({ icon: 'success', title: 'Sucesso!', text: 'Operação concluída.' });
		},
		mostrarAlertaErro(message) {
			Swal.fire({ icon: 'error', title: 'Erro!', text: message });
		},
	},
	components:{
		Commonlisting,
		CommonLoading,
		CommonForm,
		CommonEditingForm,
		FilterComponent
	}
}
</script>
